export default __webpack_public_path__ + "static/media/comingSoon.08e6e7ba.svg";